import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_94: FaireProductEntity = {
  token: "starter_collection_94",
  type: "product",
  name: "Piano Cocktail Glasses Birdland",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    "https://cdn.faire.com/fastly/c333eb0d703e716e121cee720dcb7b6c364241c007f2b49d24bb60161a54d5b0.jpeg?bg-color=FFFFFF&canvas=100p%2C100p%2Coffset-x50p%2Coffset-y50p&format=jpg&precrop=97.49p%2C64.99p%2Cx0.16p%2Cy15.5p&width=720",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
